import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';

export const Wrapper = styled.div.attrs({
  className: 'grid h-fit mx-auto relative text-center w-fit'
})`
  &.one-box {
    grid-template-rows: auto;
  }

  &.one-row {
    grid-template-columns: 1fr 24px 1fr;
    grid-template-rows: min-content auto;
  }
`;

export const GridContainer = styled.div.attrs({
  className: 'gap-8 grid'
})`
  grid-template-rows: repeat(2, auto) 48px auto;
  grid-template-columns: minmax(124px, 382px);

  @media (min-width: ${legacyBreakpoints.m}px) {
    grid-template-rows: repeat(4, auto);
  }
`;

export const Header = createComponent('p', {
  className: 'mx-auto capitalize text-blue-6 tl-header-xs m:tl-header-m'
});

export const Text = styled.div.attrs({
  className: 'mx-auto px-8 tl-body-xs text-grey-5 m:tl-body-s'
})`
  width: 90%;
`;

export const Link = createComponent('p', {
  className: 'mx-auto text-blue-2 underline tl-link-s m:tl-link-m'
});

export const Split = createComponent('div', {
  className: 'relative flex items-center justify-center m:my-20'
});
